// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopUpTitle_style_wrapper___xV72","title":"PopUpTitle_style_title__Ez_2L","closeButton":"PopUpTitle_style_closeButton__Zguic"};